// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2676":"872ccff3","9361":"872ccff3","9488":"872ccff3"}[chunkId] + ".chunk.css";
};